export default {
    pageTitle: 'Deliveries',
};
